import { siteContent } from "../content";
const about = siteContent.about;

const About = () => (
  <div className="bg-gradient-to-b from-white to-sky-50">
    <div className="container pb-16 ">
      <h2 className="text-center mb-20 text-6xl">{about.title}</h2>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-5 ">
        {about.content.map((item, k) => (
          <div
            key={k}
            className="bg-white rounded-md hover:shadow-lg hover:shadow-sky-100 transition-all duration-300"
          >
            <div className="p-10 py-14 text-lg">{item.title}</div>
          </div>
        ))}
      </div>

      <div className="overflow-hidden rounded-tl-3xl rounded-br-3xl relative w-full mt-20 mb-10">
        <img
          src="/images/cover.jpg"
          className="object-cover object-center h-72 grayscale-[30%] hover:grayscale-0 w-full transition-all duration-200"
          alt={about.title}
        />
      </div>
    </div>
  </div>
);

export default About;
